<template>
    <el-dialog
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
        center
        class="subject-pop"
    >
        <div slot="title" style="height: 30px; background-color: #fff;margin: -15px -20px;border-radius: 10px;"></div>
        <div class="popup-main">
            <div class="title">《企业会员外包服务规则》修订公示</div>
            <div class="content">
                <p class="content-block">
                    根据广大会员关于精简流程的要求，本平台对《企业会员外包服务规则》进行了适当修订，现在本平台予以公示。如会员不同意相关修改，应当停止使用并退出本平台，不影响规则修改前已发生义务及责任的承担。一旦会员继续使用本平台，则表示已接受并自愿遵守修订后的条款。</p>
                <p class="content-block">附：
                    <el-button type="text" style="font-size: 14px;text-decoration: underline"
                               @click="goPage('/agreement')">《企业会员外包服务规则》
                    </el-button>
                </p>
            </div>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button class="btn-standard" @click="disagree">不 同 意</el-button>
            <el-button class="btn-standard" type="primary" @click="agree">同 意</el-button>
        </div>
    </el-dialog>
</template>

<script>
import router from '@/router/'

export default {
    name: 'Subject',
    inject: ['goPage'],
    data () {
        return {
            dialogVisible: false
        }
    },
    created () {
        let status = localStorage.getItem('Subject') || 2
        this.dialogVisible = !(status * 1)
    },
    methods: {
        disagree () {
            localStorage.clear()
            router.replace('/login')
        },
        agree () {
            this.$http.get('/api/user/setread', {
                params: {
                    id: JSON.parse(localStorage.getItem('SubjectID'))
                }
            })
                .then(res => {
                    if (res.code === 0) {
                        localStorage.setItem('Subject', 1)
                        this.dialogVisible = false
                    } else {
                        this.$message.error(res.message)
                    }
                })
                .catch(err => {
                    console.log(err)
                })
        }
    }
}
</script>

<style scoped lang="scss">
    .popup-main {
        .title {
            text-align: center;
            font-weight: 700;
            font-size: 18px;
            margin-bottom: 30px;
        }

        .content {
            .content-block {
                line-height: 1.8;
                text-indent: 2em;
            }
        }
    }
</style>
